// oxlint-disable-next-line no-restricted-imports
import { shadowsPalette } from "#app/theme/v2/colors";

export const shadows = {
  xs: "0px 1px 2px 0px rgba(0,0,0,0.06), 0px 0px 0px 1px rgba(0,0,0,0.04)",
  elevation0: `0 1px 3px 0 ${shadowsPalette[8]}, 0 1px 2px 0 ${shadowsPalette[5]}`,
  elevation1: `0 4px 8px 0 ${shadowsPalette[8]}, 0 1px 3px 0 ${shadowsPalette[6]}`,
  elevation2: `0 0 0 1px ${shadowsPalette[2]}, 0 2px 6px 0 ${shadowsPalette[4]}, 0 4px 8px 0 ${shadowsPalette[10]}`,
  elevation3: `0 0 0 1px ${shadowsPalette[2]}, 0 8px 24px 0 ${shadowsPalette[10]}`,
  elevation4: `0 0 0 1px ${shadowsPalette[2]}, 0 4px 8px 0 ${shadowsPalette[8]}, 0 12px 30px 0 ${shadowsPalette[12]}`,
  elevation5: `0 0 0 1px ${shadowsPalette[2]}`,
  elevationHigh: `0 8px 28px 0 ${shadowsPalette[28]}`,
};
